import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, setRunnerToken } from "../lib/api";
import { PageShell } from "../components/PageShell";
import { AppText, Button, Card } from "../components/ui";
import { Seo } from "../components/Seo";

export default function Connexion() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const [codeSent, setCodeSent] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const login = async () => {
    if (!/\S+@\S+\.\S+/.test(email.trim())) { toast.error("Cet email ne semble pas valide"); return; }
    if (!/^\d{6}$/.test(code.trim())) { setErrorMsg("Ton code fait 6 chiffres. Renvoie-le si tu l'as perdu."); return; }
    setLoading(true); setErrorMsg("");
    try {
      const res = await api.runnerLogin(email.trim(), code.trim());
      if (res.session_token) {
        setRunnerToken(res.session_token);
        navigate("/programme");
      } else { setErrorMsg("Connexion impossible. Réessaie."); }
    } catch (e) { setErrorMsg(e.message || "Email ou code incorrect."); } finally { setLoading(false); }
  };

  const resend = async () => {
    if (!/\S+@\S+\.\S+/.test(email.trim())) { toast.error("Entre d'abord ton email"); return; }
    setResending(true);
    try {
      await api.runnerResendCode(email.trim());
      setCodeSent(true);
      toast.success("Si un compte existe, ton code vient d'être envoyé par email");
    } catch (e) { toast.error(e.message || "Erreur"); } finally { setResending(false); }
  };

  const field = "w-full min-h-[52px] bg-white rounded-2xl border-2 border-km-border px-4 font-text font-semibold text-[17px] text-km-ink outline-none focus:border-km-coral";

  return (
    <PageShell>
      <Seo title="Me connecter" description="Connexion à ton espace KM01 avec ton email et ton code d'accès personnel." noindex />
      <AppText variant="display" className="mt-4">Me connecter</AppText>
      <Card className="mt-6 flex flex-col gap-3">
        <AppText variant="body" className="text-km-ontertiary">Entre l'email utilisé lors du paiement et ton code d'accès personnel à 6 chiffres (reçu par email).</AppText>
        <input data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="ton@email.fr" className={field} />
        <input data-testid="login-code" value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
          inputMode="numeric" autoComplete="one-time-code" placeholder="Code à 6 chiffres"
          className={field + " tracking-[0.4em] text-center"} />
        {errorMsg ? <AppText variant="body" className="text-km-error" testID="login-error">{errorMsg}</AppText> : null}
        <Button title="Me connecter" onClick={login} loading={loading} testID="login-submit" />
        <button data-testid="login-resend" onClick={resend} disabled={resending}
          className="mt-1 font-text font-bold text-[14px] text-km-coral hover:underline disabled:opacity-50">
          {resending ? "Envoi…" : "Je n'ai pas mon code — me l'envoyer par email"}
        </button>
        {codeSent ? (
          <AppText variant="caption" className="text-km-muted" testID="login-code-sent">
            Regarde ta boîte mail (et les spams). Ton code y est aussi rappelé dans « Mon compte » une fois connecté.
          </AppText>
        ) : null}
        <div className="mt-2 pt-3 border-t border-km-divider">
          <AppText variant="caption" className="text-km-muted">Pas encore de programme ? Commence par ton profil, c'est gratuit.</AppText>
          <Button title="Faire mon profil (5 min)" variant="secondary" size="md" onClick={() => navigate("/profil")} className="mt-2" />
        </div>
      </Card>
    </PageShell>
  );
}
